import React from 'react';
import schema from './schema';
import uiSchema from './uiSchema';
import { MuiFormBuilder } from 'components';
import { FormattedMessage } from 'react-intl';

const Form = ({ formData = {}, loading, onSubmit }) => {
  return (
    <MuiFormBuilder
      submit={<FormattedMessage id="login" />}
      loading={loading}
      formData={formData}
      onSubmit={onSubmit}
      schema={schema()}
      uiSchema={uiSchema()}
      submitFullWidth
    />
  );
};

export default Form;
